import styled from 'styled-components';

export const Container = styled.div`
  margin: 2rem 0;
`;

export const AddQuestionBox = styled.div`
  padding: 2rem;
  border: 1px solid #e4e4e4;
  background: #fbfbfb;
  margin-bottom: 2rem;
`;

export const Section = styled.div`
  margin-bottom: 20px;
`;

export const QuestionListSection = styled.div`
  margin: 2rem 0;
  padding: 2rem;
  border: 1px solid #e3e3e3;
  background: #fbfbfb;
`;

export const CreateCombinationSection = styled.div`
  margin: 2rem 0;
  padding: 2rem;
  border: 1px solid #e3e3e3;
  background: #fbfbfb;
`;

export const CombinationListSection = styled.div`
  margin: 2rem 0;
  padding: 2rem;
  border: 1px solid #e3e3e3;
  background: #fbfbfb;
`;

export const Title = styled.div`
  color: #343434;
  margin-bottom: 1rem;
  font-weight: 700;
  color: #565656;
  font-size: 16px;
`;

export const Input = styled.input`
  display: block;
  width: 100%;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #adadad !important;
  border-radius: 4px;
  font-size: 16px;
`;

export const QuestionsList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
`;

export const QuestionsListItem = styled.div`
  position: relative;
  padding: 1.5rem;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  box-shadow: 1px 1px 9px 1px #f6f6f6;
  background: #fff;
`;

export const ButtonLink = styled.button`
  border: none;
  color: rgb(75, 40, 109);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  text-decoration: underline;
  background: none;
`;

export const Button = styled.button`
  padding: 0.75rem 2rem;
  margin: 5px 0;
  border: none;
  border-radius: 4px;
  background-color: #2b8000;
  color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  border: 1px solid #2b8000;

  &:hover {
    background-color: #fff;
    color: #2b8000;
    border: 1px solid #2b8000;
  }

  &:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
  }
`;

export const List = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const ListItem = styled.li`
  background: #ffffff;
  padding: 2rem;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin-bottom: 10px;
  box-shadow: 1px 1px 9px 1px #f6f6f6;
`;

export const OptionList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  list-style-type: auto;
  margin: 1rem;
  font-weight: 600;
  font-size: 14px;
  color: #454545;
`;

export const CreateCombinationOptionList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  list-style-type: none;
  margin: 1rem 0;
  font-weight: 600;
  font-size: 14px;
  color: #454545;
`;

export const CreateCombinationOptionListItem = styled.li`
  display: flex;
  gap: 0.5rem;
`;

export const CombinationOptionList = styled.ul`
  display: flex;
  flex-direction: column !important;
  gap: 0.5rem;
  list-style-type: auto;
  margin: 1rem;
  font-weight: 600;
  font-size: 14px;
  color: #454545;
`;

export const HighlightedOption = styled.span`
  color: #007bff;
  font-weight: bold;
`;

export const AddButtonContainer = styled.div`
  margin-top: 10px;
`;

export const CreateCombinationQuestionBox = styled.div`
  background: #ffffff;
  padding: 15px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  margin-bottom: 10px;
`;

export const CombinationQuestionBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: self-start;
  background: #f2eff4;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 1rem 1.5rem;
`;

export const PriceContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  background: #fff !important;
`;

export const PriceLabel = styled.span`
  color: #6c757d;
  font-size: 13px;
  font-weight: 700;
`;

export const PriceValue = styled.span`
  font-size: 1.35rem;
  font-weight: bold;
  color: #343a40;
`;

export const GridBox = styled.div`
  display: grid;
  grid-template-columns: 2.5fr 1fr 1fr;
  column-gap: 1rem;
`;

export const Strong = styled.div`
  font-weight: 700;
`;

export const CombinationQuestions = styled.div`
  display: flex;
  gap: 1rem;
  background: rgb(255, 255, 255);
  align-items: self-start;
  margin-top: 1rem;
`;

export const PriceContainerMain = styled.div`
  display: flex;
  gap: 2.5rem;
  margin-top: 1rem;
  background: #fff;
`;

export const SVGButtonWrapper = styled.button`
  position: absolute;
  right: -16px;
  top: -9px;
  background: none;
  border: 0;
`;

export const SVGButtonWrapperNormal = styled.button`
  right: -16px;
  top: -9px;
  background: none;
  border: 0;
`;
